'use client';

import { useRef } from 'react';
import PageType from '@alltrails/amplitude/enums/PageType';
import useLogWebSectionViewed from '@alltrails/layout/hooks/useLogWebSectionViewed';

type Props = {
  children: React.ReactNode;
  pageType: PageType;
};

const ParkSectionWrapper = ({ children, pageType }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  useLogWebSectionViewed(ref, 'Visitor Info', pageType, { threshold: 0.6 });

  return <div ref={ref}>{children}</div>;
};

export default ParkSectionWrapper;
